import { registerInitialState } from '../state/RegisterState'

import type { RegisterActions } from '../actions/RegisterActions.types'

import { RegisterState } from '../../helpers/types/redux/state/register.types'
import { RegisterActionType } from '../../helpers/types/redux/actions/register.types'

export function registerReducer(
  state: RegisterState,
  action: RegisterActions
): RegisterState {
  switch (action.type) {
    case RegisterActionType.Customer:
    case RegisterActionType.BusinessLicense:
      return {
        ...state,
        customer: {
          ...state.customer,
          ...action.payload,
        },
      }
    case RegisterActionType.Business:
    case RegisterActionType.BusinessAddress:
    case RegisterActionType.BusinessAddressByZipcode:
      return {
        ...state,
        business: {
          ...state.business,
          ...action.payload,
        },
      }
    case RegisterActionType.Configuration:
      return {
        ...state,
        configuration: action.payload,
      }
    case RegisterActionType.Characteristics:
      return {
        ...state,
        characteristics: action.payload,
      }
    case RegisterActionType.Reset:
      return registerInitialState
    default:
      return state
  }
}
